.RtrErrorsContainer
    position: fixed
    bottom: 100px
    right: 20px
    width: 400px
    min-height: 0
    display: flex
    flex-direction: column-reverse
    gap: 10px
    z-index: $indexAlert
    @media #{$mobile}
        right: 0
        bottom: 0
        width: 100%
    .RtrErrorContainer
        position: absolute
        transition: bottom .3s ease-in-out
        right: 0
        width: 100%
        height: 70px
        @media #{$mobile}
            height: 80px
        .RtrErrorPauseable
            &:hover 
                animation-play-state: paused
                .RtrErrorContainerTimer
                    animation-play-state: paused
        .RtrErrorContainerInner
            position: absolute
            width: 100%
            height: 70px
            display: flex
            flex-direction: column
            padding: 10px 20px
            border-radius: $globalSettingsRounding
            color: rgb($globalErrorFont)
            background-color: rgb($globalErrorBackground)
            box-shadow: $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05), $globalSettingsShadowPrimary rgba($globalSettingsBackgroundShadowColor,0.05)
            animation-name: moveAnimation
            animation-duration: 10s
            animation-timing-function: ease-in-out
            animation-fill-mode: forwards
            border-radius: $globalSettingsRounding
            overflow: hidden
            @media #{$mobile}
                height: 80px
                border-radius: 0
            .RtrErrorContainerTimer
                position: absolute
                top: 0
                left: 0
                width: 100%
                height: 5px
                background: rgb($globalErrorFont)
                animation: countAnimation 9.7s linear forwards
                opacity: 0.3
            .RtrErrorBox
                display: -webkit-box
                text-overflow: ellipsis
                overflow: hidden
                -webkit-box-orient: vertical
                -webkit-line-clamp: 2
            .RtrErrorTitle
                width: 100%
                display: flex
                justify-content: space-between
                align-items: center
                font-weight: 700
                svg
                    cursor: pointer
                    stroke: rgb($globalErrorFont)
                    transition: hover .3s
                    &:hover
                        opacity: 0.8
        .RtRSuccess
            background-color: #55CC99
@keyframes moveAnimation
    0%
        right: -430px
    3%
        right: 0
    97%
        right: 0
    100%
        right: -430px
@keyframes countAnimation
    0%
        width: 100%
    100%
        width: 0